<table mat-table [dataSource]="dataSource" matSort matSortActive="semesterYear" matSortDisableClear matSortDirection="desc" class="">

    <!-- semesterYear Column -->
    <ng-container matColumnDef="semesterYear">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> 學年度 </th>
      <td mat-cell *matCellDef="let element"> {{element.semesterYear}} </td>
    </ng-container>

    <ng-container matColumnDef="grand">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> 年級 </th>
      <td mat-cell *matCellDef="let element"> {{element.grand}}年 </td>
    </ng-container>

    <!-- classNumber Column -->
    <ng-container matColumnDef="classNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> 班級 </th>
      <td mat-cell *matCellDef="let element"> {{element.classNumber}}班 </td>
    </ng-container>

    <!-- siteName Column -->
    <ng-container matColumnDef="siteName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> 導師</th>
      <td mat-cell *matCellDef="let element"> {{element.siteName}} 老師</td>
    </ng-container>

    <!-- siteUrl Column -->
    <ng-container matColumnDef="siteUrl">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> 網站網址 </th>
      <td mat-cell *matCellDef="let element">
          <a href="{{element.siteUrl}} " target="_blank" rel="{{element.siteUrl}} ">
            {{element.siteUrl}}
          </a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class=""></tr>
  </table>
  <div *ngIf="noData | async" class="no-records">
    目前沒有資料
  </div>
  <mat-paginator class="class-websites-paginator"
    [length]="20"
    [pageSize]="20"
    [pageSizeOptions]="[20, 50, 100]"
    showFirstLastButtons></mat-paginator>

  <!-- <div *ngFor="let wb of wbs | async">
    {{wb | json}}
  </div> -->
